export function OpportunityOverviewCard(props: {
  title: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-zinc-700 dark:bg-zinc-900 min-w-0 overflow-hidden">
      <div className="mb-2 flex items-start justify-between gap-2">
        <h4 className="text-xs uppercase tracking-wide text-gray-500 dark:text-zinc-400">
          {props.title}
        </h4>
        {props.headerRight ? <div className="shrink-0">{props.headerRight}</div> : null}
      </div>
      <div className="space-y-1">{props.children}</div>
    </div>
  );
}

export function OpportunityReadOnlyRow(props: { label: string; value: string | null; mono?: boolean }) {
  return (
    <div className="flex items-start gap-2 py-1">
      <span className="text-xs uppercase tracking-wide text-gray-500 dark:text-zinc-400 w-24 shrink-0 pt-0.5">
        {props.label}
      </span>
      <span
        className={
          "text-sm text-gray-900 dark:text-zinc-100 break-words " +
          (props.mono ? "font-mono text-xs" : "")
        }
      >
        {props.value || <span className="text-gray-400 dark:text-zinc-500">—</span>}
      </span>
    </div>
  );
}

export function OpportunityStat(props: { label: string; value: string; emphasis?: boolean }) {
  return (
    <div className="rounded-xl border border-gray-100 bg-gray-50 px-3 py-2 dark:border-zinc-700 dark:bg-zinc-800/70">
      <div className="text-[11px] uppercase tracking-wide text-gray-500 dark:text-zinc-400">
        {props.label}
      </div>
      <div
        className={
          "mt-0.5 font-semibold tabular-nums text-gray-900 dark:text-zinc-100 " +
          (props.emphasis ? "text-lg" : "text-sm")
        }
      >
        {props.value}
      </div>
    </div>
  );
}
